import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { KpiMetricsService } from 'src/services/data/kpi-metrics.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import {
  loadTruckKpis,
  loadTruckKpisSuccess,
  loadTruckKpisFailure,
  loadOceanKpis,
  loadOceanKpisSuccess,
  loadOceanKpisFailure,
} from './kpi-metrics.actions'

@Injectable()
export class KpiMetricsEffects {
  private actions$ = inject(Actions)
  private KpiMetrics = inject(KpiMetricsService)
  private toaster = inject(ToasterService)


  loadTruckKpis$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTruckKpis),
      switchMap(() =>
        from(this.KpiMetrics.getTruckKpis()).pipe(
          map((kpis) => loadTruckKpisSuccess({ kpis })),
          catchAndLog(this.toaster, 'Unable to fetch truck KPIs', loadTruckKpisFailure)
        )
      )
    )
  )

  loadOceanKpis$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadOceanKpis),
      switchMap(() =>
        from(this.KpiMetrics.getOceanKpis()).pipe(
          map((kpis) => loadOceanKpisSuccess({ kpis })),
          catchAndLog(this.toaster, 'Unable to fetch ocean KPIs', loadOceanKpisFailure)
        )
      )
    )
  )
}
